/**
 * Seit 15.10.2026 wohnen die deutschen Kartentitel in shared/werkzeug-namen.ts — der Server setzt sie als Titel der
 * Anzeige (server/werkzeug-anzeige.ts). Wer sie hier holt, bekommt sie weiter.
 */
export * from "../../shared/werkzeug-namen.js";
